import {
  ActivityReportingRequirementsViewModel,
  UpdateActivityReportingRequirementsModel
} from '../../../../../features/activities/editActivity/editReportingRequirements/types';
import { UseFieldArrayReturn, UseFormReturn } from 'react-hook-form';
import { Box, Flex, Heading } from '@chakra-ui/react';
import { BaseCard, FormContainer } from '@cks-internal/react-base';
import { CompanyReportingRequirementsDisplay } from '../../../../../features/activities/editActivity/editReportingRequirements/components/companyReportingRequirementsDisplay';
import { TravellerReportingRequirementsDisplay } from '../../../../../features/activities/editActivity/editReportingRequirements/components/travellerReportingRequirementsDisplay';
import ActivityStatus from '../../../../../enums/activities/ActivityStatus.ts';

type Props = {
  companyId: number | undefined;
  viewModel: ActivityReportingRequirementsViewModel | undefined;
  formMethods: UseFormReturn<UpdateActivityReportingRequirementsModel>;
  onSubmit?: (values: UpdateActivityReportingRequirementsModel) => void;
  isDisabled: boolean;
  hasBookedHotel: boolean;
  activityStatus?: ActivityStatus;
  companyFieldArray: UseFieldArrayReturn<
    UpdateActivityReportingRequirementsModel,
    'CompanyReportingRequirements',
    'id'
  >;
  travellerFieldArray: UseFieldArrayReturn<
    UpdateActivityReportingRequirementsModel,
    'TravellerReportingRequirements',
    'id'
  >;
};

export const ReportingRequirementsForm = (props: Props) => {
  return (
    <>
      {(!props.companyId || !props.viewModel) && (
        <BaseCard
          header={
            <Box>
              <Heading>Reporting Requirements</Heading>
              <Box>Select a company to view reporting requirements.</Box>
            </Box>
          }
          variant={'fieldArray'}></BaseCard>
      )}

      {props.viewModel &&
        props.companyId &&
        props.viewModel.CompanyReportingRequirements.length == 0 &&
        (props.viewModel.TravellerReportingRequirements.length == 0 ||
          props.viewModel.TravellerReportingRequirements.flatMap((r) => r.ReportingRequirements).length == 0) && (
          <BaseCard
            header={
              <Box>
                <Heading>Reporting Requirements</Heading>
                <Box>No reporting requirements found for selected company.</Box>
              </Box>
            }
            variant={'fieldArray'}></BaseCard>
        )}

      {props.viewModel && (
        <FormContainer methods={props.formMethods} onSubmit={props.onSubmit} hideControls={!props.onSubmit}>
          <Flex gap={'4px'} flexDir={'row'} flexWrap={'wrap'}>
            <CompanyReportingRequirementsDisplay
              fieldArray={props.companyFieldArray.fields}
              formMethods={props.formMethods}
              viewModels={props.viewModel.CompanyReportingRequirements}
              isDisabled={props.isDisabled}
              hasBookedHotel={props.hasBookedHotel}
            />
            {props.viewModel.TravellerReportingRequirements.map((val, key) => {
              return (
                <TravellerReportingRequirementsDisplay
                  key={key}
                  viewModels={props.viewModel!.TravellerReportingRequirements.flatMap(
                    (val) => val.ReportingRequirements
                  )}
                  fieldArray={props.travellerFieldArray.fields}
                  formMethods={props.formMethods}
                  travellerName={val.TravellerName}
                  travellerId={val.TravellerId}
                  isDisabled={props.isDisabled}
                  hasBookedHotel={props.hasBookedHotel}
                  activityStatus={props.activityStatus}
                />
              );
            })}
          </Flex>
        </FormContainer>
      )}
    </>
  );
};
